/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_Q3Inputs */

const en_formatter_faq_q3 = /** @type {(inputs: Formatter_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I format invalid JSON?`)
};

const ko_formatter_faq_q3 = /** @type {(inputs: Formatter_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유효하지 않은 JSON도 포맷할 수 있나요?`)
};

const ja_formatter_faq_q3 = /** @type {(inputs: Formatter_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なJSONをフォーマットできますか？`)
};

/**
* | output |
* | --- |
* | "Can I format invalid JSON?" |
*
* @param {Formatter_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_q3 = /** @type {((inputs?: Formatter_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_q3(inputs)
	if (locale === "ko") return ko_formatter_faq_q3(inputs)
	return ja_formatter_faq_q3(inputs)
});